import { createContext, useContext } from 'react';

type InstitutionInternalNav = {
  /** Onglet « Tableaux BI » (dashboards d’analyse personnalisables). */
  openBiStudio: () => void;
  /** Ouvre un onglet de l’espace établissement (ex. `flows`, `learners`). */
  openTab: (tabId: string) => void;
};

export const InstitutionInternalNavContext = createContext<InstitutionInternalNav | null>(null);

export function useInstitutionInternalNav(): InstitutionInternalNav | null {
  return useContext(InstitutionInternalNavContext);
}
